import { CartStateGetSet } from "@/cart/types";
import GRAPHQL_CLIENT from "@/graphql/client";
import { Cart } from "@/graphql/generated";

export const initializeCart = ({ set, get }: CartStateGetSet) => {
  return async () => {
    const { cartId } = get();
    if (!cartId) return;

    const { cart } = await GRAPHQL_CLIENT.GetCart({ cartId });
    if (!cart) {
      set({
        cartId: undefined,
        cart: undefined,
      });
      return;
    }

    set({
      cartId: cart.id,
      cart: cart as Cart,
    });
  };
};
